
import apiClient from '../helpers/apiClient';

import { authHeader } from '../helpers/authHeader';


export const debitNoteService = {
  debitNoteList,
  submitDebitNote,
  debitNoteDetails,
  debitNoteStatus,
  debitNoteByDate,
  debitNoteSearch,
};



async function  debitNoteByDate(form) {
    return  apiClient.post(`/inventory/debit-note-by-date`, form, authHeader());
}
async function  debitNoteSearch(searchText) {
    return  apiClient.get(`/inventory/debit-note-search?search=${searchText}`, authHeader());
}




async function  debitNoteList() {
    return  apiClient.get(`/inventory/debit-note`, authHeader());
}


async function  debitNoteDetails(id) {
    return  apiClient.get(`/inventory/debit-note-details/${id}`, authHeader());
}


async function  submitDebitNote(form) {
    return  apiClient.post(`/inventory/submit-debit-note`, form, authHeader());
}

async function  debitNoteStatus(form) {
    return  apiClient.put(`/inventory/debit-note-status`, form, authHeader());
}











